// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 854) return "854.css";
	if (chunkId === 748) return "748.css";
	// return url for filenames based on template
	return "" + (chunkId === 179 ? "main" : chunkId) + ".css";
};